import { abortSafeController } from './abortController';
import { CHAT_LIST_INCLUDE_LABELED_FILTER_FLAG } from './chatListFetchState';

export {
  CHAT_LIST_INITIAL_ROUTE_BACKGROUND_MODE,
  CHAT_LIST_INITIAL_ROUTE_SEARCH_MODE,
  CHAT_LIST_PAGE_CHANGE_NOOP_STATUS,
  CHAT_LIST_PAGE_CHANGE_SEARCH_STATUS,
  CHAT_LIST_PAGE_CHANGE_NORMAL_STATUS,
  CHAT_LIST_SEARCH_QUERY_ACTION_CLEAR,
  CHAT_LIST_SEARCH_QUERY_ACTION_APPLY_ACTIVE,
  CHAT_LIST_SEARCH_QUERY_ACTION_NOOP,
  CHAT_LIST_SEARCH_INCLUDE_MESSAGE_SEARCH_FLAG,
  CHAT_LIST_SEARCH_PREVIEW_FLAG,
  CHAT_LIST_INCLUDE_LABELED_FILTER_FLAG,
  resolveChatListTotalPages,
  hasChatListAppliedFilters,
  hasChatListPriorityConversations,
  resolveChatListCurrentPageFilterKey,
  shouldShowChatListAssignee,
  resolveChatListSearchContactId,
  buildChatListSearchRequestParams,
  extractChatListSearchPayload,
  shouldApplyChatListSearchResponse,
  buildChatListSearchStartState,
  resolveChatListSearchResultsState,
  buildChatListSearchSuccessState,
  buildChatListSearchErrorState,
  normalizeChatListSearchQuery,
  runChatListSearchResultsLoad,
  buildChatListSearchResultsLoadContext,
  buildChatListSearchClearState,
  buildChatListResetBeforeFetchState,
  runChatListFetchSafely,
  runChatListArchivedConversationsDirectFetch,
  runChatListResetAndFetchData,
  runChatListFilteredConversationsLoad,
  buildChatListStatusRouteUpdate,
  shouldNavigateChatListRoute,
  shouldClearChatListSearchResults,
  buildChatListSearchClearedRouteQuery,
  runChatListClearSearchResults,
  resolveChatListInitialRoutePlan,
  buildChatListPageChangePlan,
  runChatListPageChange,
} from './chatListFetchState';

const DEFAULT_ASSIGNEE_TYPES = {
  ALL: 'all',
};

const DEFAULT_SORT_TYPES = {
  LAST_ACTIVITY_AT_DESC: 'last_activity_at_desc',
};

export const CHAT_LIST_CONVERSATION_UNSTARRED_STATUS = 'unstarred';
export const CHAT_LIST_CLEAR_SEARCH_INPUT_EVENT = 'clearSearchInput';
export const CHAT_LIST_CONVERSATION_LOAD_EVENT = 'conversation-load';
export const CHAT_LIST_TOOLBAR_DATA_UPDATE_EVENT = 'toolbar-data-update';
export const CHAT_LIST_VIRTUAL_PROP_LABEL_KEY = 'label';
export const CHAT_LIST_VIRTUAL_PROP_CONVERSATION_TYPE_KEY = 'conversationType';
export const CHAT_LIST_VIRTUAL_PROP_SHOW_ASSIGNEE_KEY = 'showAssignee';
export const CHAT_LIST_VIRTUAL_PROP_IS_SELECTED_KEY = 'isConversationSelected';
export const CHAT_LIST_VIRTUAL_PROP_AVAILABLE_WIDTH_KEY = 'availableWidth';
export const CHAT_LIST_VIRTUAL_PROP_SELECTED_CONVERSATIONS_KEY =
  'selectedConversations';
export const CHAT_LIST_ASSIGNEE_FILTER_DEBOUNCE_MS = 120;

export {
  CHAT_LIST_ROUTE_WATCH_KEY,
  runChatListBeforeDestroy,
  runChatListMounted,
  buildChatListMountedContext,
  buildChatListBeforeDestroyContext,
} from './chatListLifecycleState';

export {
  runChatListRouteChange,
  resolveChatListFiltersFromUISettings,
  runChatListFiltersFromUISettingsApply,
  resolveChatListContactFilterQuery,
  resolveChatListSearchQueryChangeAction,
  runChatListSearchQueryChange,
  buildChatListSearchQueryRouteUpdate,
  runChatListSearchRouteQuerySync,
} from './chatListRouteFilterState';

export {
  CHAT_LIST_EMAIL_FOLDER_MOVE_ERROR_KEY,
  CHAT_LIST_EMAIL_FOLDER_MOVE_SUCCESS_KEY,
  CHAT_LIST_EMAIL_FOLDER_ASSIGNMENT_ERROR_KEY,
  CHAT_LIST_EMAIL_FOLDER_ASSIGNMENT_SUCCESS_KEY,
  CHAT_LIST_STATUS_CHANGE_ERROR_KEY,
  CHAT_LIST_STATUS_CHANGE_SUCCESS_KEY,
  CHAT_LIST_MARK_AS_UNREAD_ERROR_KEY,
  CHAT_LIST_MARK_AS_UNREAD_SUCCESS_KEY,
  CHAT_LIST_PRIORITY_CHANGE_SUCCESS_KEY,
  CHAT_LIST_ASSIGN_AGENT_ERROR_KEY,
  CHAT_LIST_ASSIGN_LABELS_ERROR_KEY,
  CHAT_LIST_BULK_UPDATE_ERROR_KEY,
  CHAT_LIST_PROVIDER_GMAIL,
  CHAT_LIST_PROVIDER_MICROSOFT,
  CHAT_LIST_PROVIDER_IMAP,
  CHAT_LIST_PROVIDER_MOVE_LABEL_ACTION_ADD_LOCAL,
  CHAT_LIST_PROVIDER_MOVE_LABEL_ACTION_REPLACE_PROVIDER,
  CHAT_LIST_PROVIDER_MOVE_LOCAL_EFFECT_REMOVE,
  CHAT_LIST_BULK_EMAIL_DRAG_MIXED_INBOX_ERROR_KEY,
  CHAT_LIST_EMAIL_DRAG_DROP_SOURCE,
  CHAT_LIST_MARK_AS_UNREAD_PENDING_TTL_MS,
  resolveChatListAssignAgentContext,
  buildChatListAssigneeSnapshots,
  resolveChatListPriorityAssignmentTargets,
  resolveChatListProviderMoveLabelAction,
  cloneChatListConversationSnapshot,
  buildChatListConversationSnapshots,
  runChatListEmailProviderMoveLocalEffect,
  runChatListOptimisticEmailProviderMove,
  rollbackChatListOptimisticEmailProviderMove,
  rollbackChatListOptimisticBulkEmailProviderMove,
  resolveChatListBulkEmailDragDropRequestState,
  runChatListBulkProviderMoveLocalEffect,
  resolveChatListAssignAgentSuccessAlert,
  resolveChatListAssignLabelsSuccessAlert,
  normalizeChatListLabelChanges,
  resolveChatListToggleStarredErrorKey,
  resolveChatListEmailFolderMoveErrorKey,
  resolveChatListBulkConversationIds,
  buildChatListBulkUpdateStatusPayload,
  scheduleChatListMarkUnreadPendingReset,
  runChatListMarkAsUnread,
  buildChatListAssignPriorityDispatchPayload,
  runChatListPriorityAssignment,
  buildChatListAssignAgentDispatchPayload,
  runChatListAssignAgent,
  buildChatListAssignLabelsDispatchPayload,
  buildChatListBulkEmailBatchPayload,
} from './chatListBulkActionState';

export {
  resolveChatListKeyboardNavigationTargetIndex,
  extractChatListResizeObserverWidth,
  resolveChatListContainerWidthUpdate,
  runChatListWindowResize,
  runChatListResizeObserverInitialize,
  runChatListResizeObserverCleanup,
  buildChatListKeyboardNavigationParams,
  buildChatListKeyboardEvents,
  runChatListKeyboardNavigation,
} from './chatListViewportState';

export {
  buildChatListSilentRefreshStartState,
  buildChatListSilentRefreshFinishState,
  runChatListSilentRefresh,
  runChatListRefreshConversations,
  runChatListPeriodicTickStart,
  resolveChatListPollingInterval,
  runChatListPeriodicUpdateStop,
  resolveChatListShowConversationListAction,
  runChatListShowConversationListChange,
  classifyChatListMultiInboxTokenChange,
  buildChatListInboxOldTokenKey,
  shouldChatListInvalidateInboxCache,
  resolveChatListMultiInboxRefreshAction,
  runChatListMultiInboxRefreshEffect,
  resolveChatListSingleInboxRefreshAction,
  runChatListSingleInboxRefreshEffect,
  runChatListSingleInboxRefreshRequest,
  isChatListMultiInboxPollingMode,
  hasChatListAvailableInboxes,
  runChatListPeriodicRefreshTick,
  runChatListPeriodicUpdateStart,
} from './chatListPollingState';

export const buildInitialChatListState = ({
  assigneeTypes = DEFAULT_ASSIGNEE_TYPES,
  sortTypes = DEFAULT_SORT_TYPES,
  advancedFilterItems = [],
  translate = (key) => key,
  label = '',
  conversationType = '',
  isConversationSelected = () => false,
} = {}) => ({
  // Exposed as component state: templates and computeds (e.g.
  // showAssigneeInConversationCard) read this.assigneeTypes / this.sortTypes.
  // Vue 2's lazy computeds masked their absence; Vue 3 evaluates watcher
  // getters eagerly and crashed on this.assigneeTypes being undefined.
  assigneeTypes,
  sortTypes,
  controller: null,
  updateInterval: null,
  activeAssigneeTab: assigneeTypes.ALL,
  activeStatus: 'open',
  activeSortBy: sortTypes.LAST_ACTIVITY_AT_DESC,
  includeLabeledConversations: false,
  unreadFirstEnabled: false,
  priorityFilterEnabled: false,
  advancedFilterTypes: advancedFilterItems.map((filter) => ({
    ...filter,
    attributeName: translate(`FILTER.ATTRIBUTES.${filter.attributeI18nKey}`),
  })),
  isContextMenuOpen: false,
  appliedFilter: [],
  currentPage: 1,
  itemsPerPage: 30,
  totalPages: 1,
  selectedAssigneeIdFilter: null,
  virtualListExtraProps: {
    [CHAT_LIST_VIRTUAL_PROP_LABEL_KEY]: label,
    [CHAT_LIST_VIRTUAL_PROP_CONVERSATION_TYPE_KEY]: conversationType,
    [CHAT_LIST_VIRTUAL_PROP_SHOW_ASSIGNEE_KEY]: false,
    [CHAT_LIST_VIRTUAL_PROP_IS_SELECTED_KEY]: isConversationSelected,
  },
  showDirectConversations: false,
  isFetchingConversations: false,
  activeConversationFetchKey: null,
  conversationFetchPrefetchGeneration: 0,
  isSilentRefresh: false,
  pendingTimers: new Set(),
  isComponentDestroyed: false,
  searchQuery: '',
  activeSearchQuery: '',
  filterContactId: null,
  searchResults: [],
  searchResultsTotal: 0,
  searchResultsLoading: false,
  searchResultsError: false,
  searchResultsRequestId: 0,
  searchAbortController: null,
  isSearchModeActive: false,
  lastSeenRefreshToken: null,
  inboxRefreshTokens: null,
  isLoadingLabel: false,
  lastSeenInboxId: null,
  assigneeDebounceTimer: null,
  assigneeDebounceMs: CHAT_LIST_ASSIGNEE_FILTER_DEBOUNCE_MS,
  operationInProgress: false,
  operationDepth: 0,
});

export const buildChatListCurrentUserDetails = (currentUser = {}) => ({
  id: currentUser?.id,
  name: currentUser?.name,
});

export const runChatListAbortControllerClear = ({
  abortController = null,
  abortControllerSafely = abortSafeController,
  setAbortController = null,
} = {}) => {
  if (!abortController) {
    return { aborted: false, controller: abortController };
  }

  if (typeof abortControllerSafely === 'function') {
    abortControllerSafely(abortController);
  }

  if (typeof setAbortController === 'function') {
    setAbortController(null);
  }

  return { aborted: true, controller: null };
};

export const buildChatListOperationStartState = ({
  operationDepth = 0,
} = {}) => ({
  operationDepth: operationDepth + 1,
  operationInProgress: true,
});

export const buildChatListOperationFinishState = ({
  operationDepth = 0,
  operationInProgress = false,
} = {}) => {
  let nextOperationDepth = operationDepth;
  let nextOperationInProgress = operationInProgress;

  if (nextOperationDepth > 0) {
    nextOperationDepth -= 1;
  }

  if (nextOperationDepth === 0) {
    nextOperationInProgress = false;
  }

  return {
    operationDepth: nextOperationDepth,
    operationInProgress: nextOperationInProgress,
  };
};

export const buildChatListVirtualListPropsUpdate = ({
  currentProps = {},
  key = '',
  value,
} = {}) => {
  if (!key) {
    return { ...currentProps };
  }

  return {
    ...currentProps,
    [key]: value,
  };
};

export const runChatListConversationLoadedEffect = ({
  emit = null,
  eventName = CHAT_LIST_CONVERSATION_LOAD_EVENT,
  getVirtualList = null,
  nextTick = null,
  offsetStep = 1,
} = {}) => {
  const shouldEmit = typeof emit === 'function' && Boolean(eventName);
  if (shouldEmit) {
    emit(eventName);
  }

  if (typeof nextTick !== 'function') {
    return { emitted: shouldEmit, status: 'emitted' };
  }

  nextTick(() => {
    const virtualList =
      typeof getVirtualList === 'function' ? getVirtualList() : null;
    const scrollToOffset = virtualList?.scrollToOffset;
    if (typeof scrollToOffset !== 'function') {
      return;
    }

    const currentOffset =
      typeof virtualList?.getOffset === 'function'
        ? virtualList.getOffset() || 0
        : 0;
    scrollToOffset(currentOffset + offsetStep);
  });

  return { emitted: shouldEmit, status: 'scheduled' };
};

export const buildChatListVisualFilterWatcherPlan = ({
  isSearchModeActive = false,
  propKey = '',
  propValue = null,
  resetReason = '',
} = {}) => ({
  resetReason,
  shouldResetFetch: !isSearchModeActive,
  shouldUpdateVirtualProp: Boolean(!isSearchModeActive && propKey),
  virtualPropKey: propKey,
  virtualPropValue: propValue,
});

export const buildChatListNewConversationOpenState = ({
  translate = (key) => key,
} = {}) => ({
  selectedContact: {
    id: 1,
    name: translate('CHAT_LIST.EXAMPLE_CONTACT'),
  },
  showNewConversationModal: true,
});

export const buildChatListNewConversationCloseState = () => ({
  showNewConversationModal: false,
});

export const buildChatListDirectConversationOpenState = (contacts = []) => ({
  selectedContacts: Array.isArray(contacts) ? contacts : [],
  showDirectConversationModal: true,
});

export const buildChatListDirectConversationCloseState = () => ({
  selectedContacts: [],
  showDirectConversationModal: false,
});

export const buildChatListDirectConversationsToggleState = ({
  showDirectConversations = false,
} = {}) => ({
  shouldRefreshConversations: true,
  showDirectConversations: !showDirectConversations,
});

export const buildChatListCustomSnoozeModalOpenState = () => ({
  showCustomSnoozeModal: true,
});

export const buildChatListCustomSnoozeModalCloseState = () => ({
  showCustomSnoozeModal: false,
});

export const buildChatListCustomSnoozeChoiceState = (
  customSnoozeTime = null
) => ({
  shouldToggleStatus: Boolean(customSnoozeTime),
  showCustomSnoozeModal: false,
  snoozeTime: customSnoozeTime || null,
});

export const CHAT_LIST_EXCLUSIVE_TOGGLE_UNREAD_FIRST = 'unreadFirst';
export const CHAT_LIST_EXCLUSIVE_TOGGLE_PRIORITY = 'priority';
export const CHAT_LIST_BASIC_FILTER_STATUS = 'status';
export const CHAT_LIST_BASIC_FILTER_SORT_BY = 'sortBy';
export const CHAT_LIST_RESET_REASON_FILTER_CHANGE = 'filter-change';
export const CHAT_LIST_RESET_REASON_USER_ACTION = 'user-action';
export const CHAT_LIST_RESET_REASON_BACKGROUND = 'background';
export const CHAT_LIST_RESET_REASON_INBOX_CHANGE = 'inbox-change';

export const resolveChatListExclusiveFilterToggle = ({
  type = '',
  unreadFirstEnabled = false,
  priorityFilterEnabled = false,
} = {}) => {
  if (type === CHAT_LIST_EXCLUSIVE_TOGGLE_UNREAD_FIRST) {
    const nextUnreadFirstEnabled = !unreadFirstEnabled;
    const settings = { unread_first_enabled: nextUnreadFirstEnabled };
    let nextPriorityFilterEnabled = priorityFilterEnabled;

    if (nextUnreadFirstEnabled && priorityFilterEnabled) {
      nextPriorityFilterEnabled = false;
      settings.priority_filter_enabled = false;
    }

    return {
      unreadFirstEnabled: nextUnreadFirstEnabled,
      priorityFilterEnabled: nextPriorityFilterEnabled,
      settings,
    };
  }

  if (type === CHAT_LIST_EXCLUSIVE_TOGGLE_PRIORITY) {
    const nextPriorityFilterEnabled = !priorityFilterEnabled;
    const settings = { priority_filter_enabled: nextPriorityFilterEnabled };
    let nextUnreadFirstEnabled = unreadFirstEnabled;

    if (nextPriorityFilterEnabled && unreadFirstEnabled) {
      nextUnreadFirstEnabled = false;
      settings.unread_first_enabled = false;
    }

    return {
      unreadFirstEnabled: nextUnreadFirstEnabled,
      priorityFilterEnabled: nextPriorityFilterEnabled,
      settings,
    };
  }

  return {
    unreadFirstEnabled,
    priorityFilterEnabled,
    settings: {},
  };
};

export const runChatListExclusiveFilterToggle = ({
  priorityFilterEnabled = false,
  resetAndFetchData = null,
  resetReason = CHAT_LIST_RESET_REASON_USER_ACTION,
  setChatListPriorityFilter = null,
  setChatListUnreadFirst = null,
  setPriorityFilterEnabled = null,
  setUnreadFirstEnabled = null,
  type = '',
  unreadFirstEnabled = false,
  updateUISettings = null,
} = {}) => {
  if (
    typeof setUnreadFirstEnabled !== 'function' ||
    typeof setPriorityFilterEnabled !== 'function' ||
    typeof updateUISettings !== 'function' ||
    typeof resetAndFetchData !== 'function'
  ) {
    return { status: 'invalid' };
  }

  const nextToggleState = resolveChatListExclusiveFilterToggle({
    type,
    unreadFirstEnabled,
    priorityFilterEnabled,
  });

  setUnreadFirstEnabled(nextToggleState.unreadFirstEnabled);
  setPriorityFilterEnabled(nextToggleState.priorityFilterEnabled);

  if (
    type === CHAT_LIST_EXCLUSIVE_TOGGLE_UNREAD_FIRST &&
    typeof setChatListUnreadFirst === 'function'
  ) {
    setChatListUnreadFirst(nextToggleState.unreadFirstEnabled);
  }

  if (
    type === CHAT_LIST_EXCLUSIVE_TOGGLE_PRIORITY &&
    typeof setChatListPriorityFilter === 'function'
  ) {
    setChatListPriorityFilter(nextToggleState.priorityFilterEnabled);
  }

  if (
    nextToggleState.settings.priority_filter_enabled === false &&
    typeof setChatListPriorityFilter === 'function'
  ) {
    setChatListPriorityFilter(false);
  }

  if (
    nextToggleState.settings.unread_first_enabled === false &&
    typeof setChatListUnreadFirst === 'function'
  ) {
    setChatListUnreadFirst(false);
  }

  updateUISettings(nextToggleState.settings);
  resetAndFetchData(resetReason);

  return {
    state: nextToggleState,
    status: 'toggled',
  };
};

export const isChatListConversationSelected = ({
  conversationId,
  selectedConversations = [],
} = {}) =>
  (Array.isArray(selectedConversations) ? selectedConversations : []).some(
    (id) => String(id) === String(conversationId)
  );

export const buildChatListConversationRemovalIds = (conversationId) => {
  const numericId = Number(conversationId);
  const idsToRemove = Number.isFinite(numericId)
    ? [conversationId, numericId, String(conversationId)]
    : [conversationId];

  return [...new Set(idsToRemove)];
};

export const buildChatListPendingActivityUpdates = ({
  conversations = [],
  pendingConversationIds = [],
} = {}) => {
  const safeConversations = Array.isArray(conversations) ? conversations : [];
  return Array.from(pendingConversationIds || [])
    .map((conversationId) =>
      safeConversations.find(
        (conversation) => String(conversation?.id) === String(conversationId)
      )
    )
    .filter(Boolean)
    .map((conversation) => ({
      conversationId: conversation.id,
      lastActivityAt: conversation.last_activity_at,
    }));
};

export const runChatListPendingActivityUpdatesCommit = ({
  buildUpdates = buildChatListPendingActivityUpdates,
  commitMutation = null,
  conversations = [],
  mutation = '',
  pendingConversationIds = [],
  scheduleNextTick = null,
} = {}) => {
  if (typeof buildUpdates !== 'function') {
    return { committedCount: 0, status: 'invalid', updates: [] };
  }

  const updates = buildUpdates({ conversations, pendingConversationIds });
  if (
    typeof commitMutation !== 'function' ||
    typeof scheduleNextTick !== 'function'
  ) {
    return { committedCount: 0, status: 'invalid', updates };
  }

  updates.forEach((payload) => {
    scheduleNextTick(() => commitMutation(mutation, payload));
  });

  return { committedCount: updates.length, status: 'scheduled', updates };
};

export const buildChatListIncludeLabeledFiltersUpdate = ({
  conversationFilters = {},
  includeLabeledConversations = false,
} = {}) => {
  const filters = { ...conversationFilters };
  if (includeLabeledConversations) {
    filters.include_labeled = CHAT_LIST_INCLUDE_LABELED_FILTER_FLAG;
  }
  return filters;
};

export const runChatListIncludeLabeledConversationsChange = ({
  buildFiltersUpdate = buildChatListIncludeLabeledFiltersUpdate,
  conversationFilters = {},
  currentPage = 1,
  fetchConversations = null,
  hasActiveSearchQuery = null,
  includeLabeledConversations = false,
  updateFilters = null,
} = {}) => {
  if (typeof hasActiveSearchQuery === 'function' && hasActiveSearchQuery()) {
    return { status: 'skipped-active-search' };
  }

  if (
    typeof buildFiltersUpdate !== 'function' ||
    typeof updateFilters !== 'function' ||
    typeof fetchConversations !== 'function'
  ) {
    return { status: 'invalid' };
  }

  const filters = buildFiltersUpdate({
    conversationFilters,
    includeLabeledConversations,
  });
  updateFilters(filters);
  fetchConversations(currentPage);

  return { status: 'updated', filters, page: currentPage };
};

export const isChatListTransitionToResolvedStatus = ({
  newStatus = null,
  oldStatus = null,
} = {}) => newStatus === 'resolved' && oldStatus !== 'resolved';

export const runChatListActiveStatusChange = ({
  bailIfActiveSearch = null,
  emptyConversations = null,
  newStatus = null,
  oldStatus = null,
  resetAndFetchData = null,
  resetPage = null,
  resetReason = null,
  shouldResetForStatus = isChatListTransitionToResolvedStatus,
} = {}) => {
  if (typeof bailIfActiveSearch === 'function' && bailIfActiveSearch()) {
    return { status: 'skipped-active-search' };
  }

  if (typeof shouldResetForStatus !== 'function') {
    return { status: 'invalid' };
  }

  if (!shouldResetForStatus({ newStatus, oldStatus })) {
    return { status: 'skipped' };
  }

  if (
    typeof emptyConversations !== 'function' ||
    typeof resetPage !== 'function' ||
    typeof resetAndFetchData !== 'function'
  ) {
    return { status: 'invalid' };
  }

  emptyConversations();
  resetPage();
  resetAndFetchData(resetReason);

  return { status: 'reset', reason: resetReason };
};

export const resolveChatListNavigationSearchQuery = ({
  activeSearchQuery = '',
  qFromEvent = '',
  routeQuery = null,
  searchQuery = '',
} = {}) => {
  const safeRouteQuery =
    routeQuery && typeof routeQuery === 'object' ? routeQuery.q : '';
  return (
    qFromEvent ||
    safeRouteQuery ||
    activeSearchQuery ||
    searchQuery ||
    ''
  )
    .toString()
    .trim();
};

export const resolveChatListNavigationActiveInbox = ({
  activeInbox = null,
  conversationInbox = null,
  routeQuery = null,
} = {}) => {
  const hasSearchQuery = Boolean(routeQuery?.q);
  if (hasSearchQuery) {
    return null;
  }
  return conversationInbox || activeInbox || null;
};

export const buildChatListContactFilterClearedState = () => ({
  filterContactId: null,
  searchQuery: '',
  activeStatus: 'open',
  includeLabeledConversations: false,
});

export const buildChatListAdvancedFiltersOpenState = () => ({
  showAdvancedFilters: true,
});

export const buildChatListAdvancedFiltersCloseState = () => ({
  appliedFilter: [],
  showAdvancedFilters: false,
});

export const buildChatListContactFilterClearedFilters = ({
  conversationFilters = {},
} = {}) => {
  const safeFilters =
    conversationFilters && typeof conversationFilters === 'object'
      ? conversationFilters
      : {};
  const next = { ...safeFilters };
  delete next.contact_id;
  next.status = 'open';
  return next;
};

export const resolveChatListNextConversationLayoutType = ({
  condensedType = '',
  currentType = '',
  expandedType = '',
} = {}) => (currentType === condensedType ? expandedType : condensedType);

export const resolveChatListConversationInboxId = (conversation = null) =>
  conversation?.inbox_id ||
  conversation?.inbox?.id ||
  conversation?.meta?.inbox?.id ||
  null;

export const resolveChatListMicrosoftNormalizedInboxId = ({
  inboxId = null,
  currentChat = null,
  chat = null,
} = {}) => inboxId || currentChat?.inbox_id || chat?.inbox_id || null;

export const buildChatListConversationStateChangedEvent = ({
  id = null,
  status = null,
} = {}) => ({
  id,
  status,
  immediate: true,
});

export const buildChatListTabChangeState = (newTab = null) => ({
  activeAssigneeTab: newTab,
  filterContactId: null,
  searchQuery: '',
});

export const buildChatListConversationAssigneeChangedEvent = ({
  id = null,
  assignee = null,
} = {}) => ({
  id,
  assignee,
  immediate: true,
});

export const shouldChatListUpdateConversationLabels = ({
  chat = null,
  labelTitle = null,
} = {}) => Boolean(chat && labelTitle);

export const isChatListAiRepliedRoute = (routeQuery = null) =>
  routeQuery?.ai_replied === 'true';

export const hasChatListActiveSearchQueryInRoute = (routeQuery = null) =>
  Boolean(routeQuery?.q);

export const buildChatListRouteContext = ({
  component = null,
  route = null,
} = {}) => {
  const resolvedRoute = route || component?.$route || {};
  const routeObject =
    resolvedRoute && typeof resolvedRoute === 'object' ? resolvedRoute : {};
  const query =
    routeObject?.query && typeof routeObject.query === 'object'
      ? routeObject.query
      : {};
  const params =
    routeObject?.params && typeof routeObject.params === 'object'
      ? routeObject.params
      : {};

  return {
    params,
    path: routeObject?.path || '',
    query,
    route: routeObject,
  };
};

export const buildChatListRouterContext = ({
  component = null,
  router = null,
} = {}) => {
  const resolvedRouter = router || component?.$router || null;

  return {
    afterEach:
      typeof resolvedRouter?.afterEach === 'function'
        ? (handler) => resolvedRouter.afterEach(handler)
        : null,
    beforeEach:
      typeof resolvedRouter?.beforeEach === 'function'
        ? (handler) => resolvedRouter.beforeEach(handler)
        : null,
    resolveHref:
      typeof resolvedRouter?.resolve === 'function'
        ? (targetLocation) => {
            try {
              return resolvedRouter.resolve(targetLocation)?.href || '';
            } catch (_) {
              return '';
            }
          }
        : null,
    router: resolvedRouter,
  };
};

export const buildChatListSearchRouteContext = ({
  component = null,
  currentQuery = null,
  replaceRouteQuery = null,
  route = null,
} = {}) => {
  const resolvedCurrentQuery =
    currentQuery || component?.$route?.query || route?.query || null;
  const resolvedReplaceRouteQuery =
    typeof replaceRouteQuery === 'function'
      ? replaceRouteQuery
      : component?.replaceRouteQuerySafely;

  return {
    currentQuery: resolvedCurrentQuery,
    hasActiveSearchQuery:
      hasChatListActiveSearchQueryInRoute(resolvedCurrentQuery),
    replaceRouteQuery:
      typeof resolvedReplaceRouteQuery === 'function'
        ? (query) => resolvedReplaceRouteQuery.call(component, query)
        : null,
  };
};

export const shouldChatListUseSectionedConversationItem = ({
  priorityFilterEnabled = false,
  unreadFirstEnabled = false,
} = {}) => Boolean(unreadFirstEnabled || priorityFilterEnabled);

export const shouldChatListDispatchConversationFiltersUpdate = ({
  areFiltersEquivalent = null,
  isLoadingLabel = false,
  newVal = null,
  oldVal = null,
} = {}) => {
  if (isLoadingLabel) {
    return false;
  }
  if (
    typeof areFiltersEquivalent === 'function' &&
    areFiltersEquivalent(newVal, oldVal)
  ) {
    return false;
  }
  return newVal !== oldVal;
};

export const runChatListConversationFiltersChange = ({
  areFiltersEquivalent = null,
  bailIfActiveSearch = null,
  isLoadingLabel = false,
  newVal = null,
  oldVal = null,
  shouldDispatchUpdate = shouldChatListDispatchConversationFiltersUpdate,
  updateFilters = null,
} = {}) => {
  if (typeof bailIfActiveSearch === 'function' && bailIfActiveSearch()) {
    return { status: 'skipped-active-search' };
  }

  if (
    typeof shouldDispatchUpdate !== 'function' ||
    typeof updateFilters !== 'function'
  ) {
    return { status: 'invalid' };
  }

  const shouldUpdate = shouldDispatchUpdate({
    areFiltersEquivalent,
    isLoadingLabel,
    newVal,
    oldVal,
  });

  if (!shouldUpdate) {
    return { status: 'skipped' };
  }

  updateFilters(newVal);

  return { status: 'updated', filters: newVal };
};

export const runChatListConversationInboxChange = ({
  activeInbox = null,
  activeInboxFilter = null,
  chatListCount = 0,
  chatListFilters = {},
  clearConversationFilters = null,
  forceUpdate = null,
  newInbox = null,
  oldInbox = null,
  resetAndFetchData = null,
  resetReason = null,
  resolveInboxChange = null,
  routePath = '',
  routeQuery = {},
  setActiveInbox = null,
} = {}) => {
  if (typeof resolveInboxChange !== 'function') {
    return { status: 'invalid' };
  }

  const inboxChange = resolveInboxChange({
    activeInbox,
    activeInboxFilter,
    chatListCount,
    chatListFilters,
    newInbox,
    oldInbox,
    routePath,
    routeQuery,
  });

  if (!inboxChange || inboxChange.action === 'none') {
    return { status: 'skipped', action: inboxChange?.action || 'none' };
  }

  if (inboxChange.shouldSyncActiveInbox) {
    if (typeof setActiveInbox !== 'function') {
      return { status: 'invalid', action: inboxChange.action };
    }
    setActiveInbox(newInbox);
  }

  if (inboxChange.shouldClearConversationFilters) {
    if (typeof clearConversationFilters !== 'function') {
      return { status: 'invalid', action: inboxChange.action };
    }
    clearConversationFilters();
  }

  if (inboxChange.shouldForceUpdate) {
    if (typeof forceUpdate !== 'function') {
      return { status: 'invalid', action: inboxChange.action };
    }
    forceUpdate();
    return { status: 'forced', action: inboxChange.action };
  }

  if (inboxChange.shouldResetFetch) {
    if (typeof resetAndFetchData !== 'function') {
      return { status: 'invalid', action: inboxChange.action };
    }
    resetAndFetchData(resetReason);
    return {
      status: 'reset',
      action: inboxChange.action,
      reason: resetReason,
    };
  }

  return { status: 'updated', action: inboxChange.action };
};

export const isChatListConversationFetchDuplicateInFlight = ({
  activeFetchKey = null,
  isFetching = false,
  requestKey = null,
} = {}) =>
  Boolean(isFetching) &&
  activeFetchKey !== null &&
  activeFetchKey === requestKey;

export const shouldChatListReplaceNavigationQuery = ({
  currentQuery = null,
  q = '',
} = {}) => Boolean(q) && currentQuery?.q !== q;

export const buildChatListNavigationRouteContext = ({
  component = null,
  pushRoute = null,
  replaceRouteQuery = null,
  route = null,
} = {}) => {
  const readCurrentQuery = () => {
    const routeQuery = component?.$route?.query || route?.query || {};
    return routeQuery && typeof routeQuery === 'object'
      ? { ...routeQuery }
      : {};
  };

  const resolvedPushRoute =
    typeof pushRoute === 'function' ? pushRoute : component?.pushRouteSafely;
  const resolvedReplaceRouteQuery =
    typeof replaceRouteQuery === 'function'
      ? replaceRouteQuery
      : component?.replaceRouteQuerySafely;

  return {
    currentQuery: readCurrentQuery(),
    pushRoute:
      typeof resolvedPushRoute === 'function'
        ? (targetLocation) => resolvedPushRoute.call(component, targetLocation)
        : null,
    refreshCurrentQuery: readCurrentQuery,
    replaceRouteQuery:
      typeof resolvedReplaceRouteQuery === 'function'
        ? (query) => resolvedReplaceRouteQuery.call(component, query)
        : null,
  };
};

export const CHAT_LIST_LABEL_SYNC_CACHE_SCOPE_ALL = 'all';
export const CHAT_LIST_LABEL_SYNC_CACHE_SCOPE_NONE = 'none';
export const CHAT_LIST_LABEL_SYNC_CACHE_SCOPE_PER_INBOX = 'per-inbox';

export const resolveChatListLabelSyncCacheScope = ({
  hasAffectedInboxes = false,
  hasConversationIds = false,
} = {}) => {
  if (hasAffectedInboxes) {
    return CHAT_LIST_LABEL_SYNC_CACHE_SCOPE_PER_INBOX;
  }
  if (hasConversationIds) {
    return CHAT_LIST_LABEL_SYNC_CACHE_SCOPE_ALL;
  }
  return CHAT_LIST_LABEL_SYNC_CACHE_SCOPE_NONE;
};

export const resolveChatListActiveStatusFromFilters = (newFilters = null) => {
  if (!newFilters || typeof newFilters !== 'object') {
    return null;
  }
  return newFilters.status ? newFilters.status : null;
};

export const runChatListFiltersStoreChange = ({
  filters = null,
  resolveActiveStatus = resolveChatListActiveStatusFromFilters,
  setActiveStatus = null,
} = {}) => {
  if (
    typeof resolveActiveStatus !== 'function' ||
    typeof setActiveStatus !== 'function'
  ) {
    return { status: 'invalid' };
  }

  const nextStatus = resolveActiveStatus(filters);
  if (!nextStatus) {
    return { status: 'skipped' };
  }

  setActiveStatus(nextStatus);
  return { status: 'updated', activeStatus: nextStatus };
};

export const runChatListActiveInboxChange = ({
  forceUpdate = null,
  newInboxId = null,
  oldInboxId = null,
} = {}) => {
  if (newInboxId === oldInboxId) {
    return { status: 'skipped' };
  }

  if (typeof forceUpdate !== 'function') {
    return { status: 'invalid' };
  }

  forceUpdate();
  return { status: 'forced' };
};

export const isChatListArchivedRouteName = (name = null) =>
  typeof name === 'string' && name.includes('archived');

export const shouldChatListResetOnArchivedTransition = ({
  toName = null,
  fromName = null,
} = {}) =>
  isChatListArchivedRouteName(toName) && !isChatListArchivedRouteName(fromName);

export const runChatListArchivedRouteBeforeEach = ({
  emptyConversations = null,
  fromName = null,
  next = null,
  resetPage = null,
  shouldReset = shouldChatListResetOnArchivedTransition,
  toName = null,
} = {}) => {
  const shouldResetList =
    typeof shouldReset === 'function' && shouldReset({ toName, fromName });

  if (shouldResetList) {
    if (typeof emptyConversations === 'function') {
      emptyConversations();
    }

    if (typeof resetPage === 'function') {
      resetPage();
    }
  }

  if (typeof next === 'function') {
    next();
  }

  return { shouldReset: shouldResetList, status: 'handled' };
};

export const shouldProcessChatListConversationStateChange = ({
  id = null,
  immediate = false,
} = {}) => Boolean(immediate) && id != null && id !== '';

export const CHAT_LIST_DEFAULT_PREFETCH_REQUEST_OPTIONS = Object.freeze({
  force: false,
});

export const resolveChatListPrefetchPoolSize = ({
  concurrency = 1,
  queueLength = 0,
} = {}) => {
  const safeConcurrency = Number.isFinite(concurrency)
    ? Math.max(0, Math.floor(concurrency))
    : 0;
  const safeQueueLength = Number.isFinite(queueLength)
    ? Math.max(0, Math.floor(queueLength))
    : 0;
  return Math.min(safeConcurrency, safeQueueLength);
};

export const buildChatListUniqueConversationIdQueue = (ids = []) =>
  Array.isArray(ids) ? Array.from(new Set(ids)) : [];

export const runChatListConversationPrefetch = async ({
  action = null,
  concurrency = 1,
  dispatch = null,
  ids = [],
  requestOptions = CHAT_LIST_DEFAULT_PREFETCH_REQUEST_OPTIONS,
} = {}) => {
  const queue = buildChatListUniqueConversationIdQueue(ids);
  const poolSize = resolveChatListPrefetchPoolSize({
    concurrency,
    queueLength: queue.length,
  });

  if (poolSize === 0 || typeof dispatch !== 'function') {
    return {
      poolSize,
      queued: queue.length,
      status: 'skipped',
    };
  }

  let cursor = 0;
  const worker = () => {
    if (cursor >= queue.length) {
      return Promise.resolve();
    }

    const idx = cursor;
    cursor += 1;
    const conversationId = queue[idx];

    return Promise.resolve(
      dispatch(action, {
        ...(requestOptions || {}),
        conversationId,
      })
    )
      .catch(() => {})
      .then(worker);
  };

  const workers = Array.from({ length: poolSize }, () => worker());
  await Promise.all(workers);

  return {
    poolSize,
    queued: queue.length,
    status: 'prefetched',
  };
};

export const shouldChatListSyncSortFilter = ({
  activeSortBy = null,
  currentSort = null,
} = {}) => Boolean(activeSortBy) && currentSort !== activeSortBy;

export const resolveChatListBasicFilterInboxId = ({
  conversationInbox = null,
  routeParams = null,
} = {}) => {
  if (conversationInbox) return conversationInbox;
  const paramId = routeParams?.inbox_id;
  return paramId || null;
};

export const extractChatListConversationCurrentLabels = (
  conversation = null
) => (Array.isArray(conversation?.labels) ? conversation.labels : []);

export const buildChatListConversationFallbackRouteTarget = ({
  conversationId = null,
  accountId = null,
  query = {},
} = {}) => ({
  name: 'inbox_conversation',
  params: {
    conversation_id: conversationId,
    accountId,
  },
  query,
});

export const runChatListConversationNavigation = async ({
  accountId = null,
  activeInbox = null,
  activeSearchQuery = '',
  buildFallbackTarget = buildChatListConversationFallbackRouteTarget,
  conversationId = null,
  conversationInbox = null,
  conversationType = '',
  currentQuery = {},
  frontendUrlBuilder = null,
  label = '',
  pushRoute = null,
  qFromEvent = '',
  refreshCurrentQuery = null,
  replaceRouteQuery = null,
  resolveActiveInbox = resolveChatListNavigationActiveInbox,
  resolveSearchQuery = resolveChatListNavigationSearchQuery,
  routeBuilder = null,
  searchQuery = '',
  shouldReplaceQuery = shouldChatListReplaceNavigationQuery,
} = {}) => {
  if (typeof pushRoute !== 'function') {
    return { status: 'invalid' };
  }

  let nextQuery =
    currentQuery && typeof currentQuery === 'object' ? currentQuery : {};
  const q = resolveSearchQuery({
    activeSearchQuery,
    qFromEvent,
    routeQuery: nextQuery,
    searchQuery,
  });

  if (shouldReplaceQuery({ currentQuery: nextQuery, q })) {
    const replaced =
      typeof replaceRouteQuery === 'function'
        ? await replaceRouteQuery({ ...nextQuery, q })
        : false;
    if (replaced && typeof refreshCurrentQuery === 'function') {
      nextQuery = refreshCurrentQuery();
    }
  }

  const effectiveActiveInbox = resolveActiveInbox({
    activeInbox,
    conversationInbox,
    routeQuery: nextQuery,
  });

  try {
    if (
      typeof frontendUrlBuilder !== 'function' ||
      typeof routeBuilder !== 'function'
    ) {
      throw new Error('Missing route builder');
    }
    const path = frontendUrlBuilder(
      routeBuilder({
        accountId,
        activeInbox: effectiveActiveInbox,
        id: conversationId,
        label,
        conversationType,
      })
    );
    pushRoute({ path, query: nextQuery });
    return { status: 'navigated', query: nextQuery };
  } catch (err) {
    pushRoute(
      buildFallbackTarget({
        conversationId,
        accountId,
        query: nextQuery,
      })
    );
    return { status: 'fallback', query: nextQuery };
  }
};

export const resolveChatListInboxChannelType = (inbox = null) =>
  inbox?.channel_type || 'unknown';

export const buildChatListConversationLayoutSettings = (newViewType = '') => ({
  conversation_display_type: newViewType,
  previously_used_conversation_display_type: newViewType,
});

export const buildChatListToggleStarredDispatchPayload = ({
  id = null,
  value = false,
} = {}) => ({
  conversationId: id,
  starred: Boolean(value),
});

export const CHAT_LIST_PENDING_CONVERSATION_TTL_MS = 4000;
export const CHAT_LIST_DEFAULT_PREFETCH_CONCURRENCY = 3;
export const CHAT_LIST_ARCHIVED_FETCH_DELAY_MS = 200;

export const scheduleChatListArchivedFetch = ({
  delayMs = CHAT_LIST_ARCHIVED_FETCH_DELAY_MS,
  fetchConversations = null,
  routeName = null,
  scheduleTimer = null,
} = {}) => {
  if (
    !isChatListArchivedRouteName(routeName) ||
    typeof fetchConversations !== 'function' ||
    typeof scheduleTimer !== 'function'
  ) {
    return null;
  }

  return scheduleTimer(() => fetchConversations(1), delayMs);
};

export const scheduleChatListAssigneeFilterFetch = ({
  clearTimer = null,
  currentTimer = null,
  delayMs = CHAT_LIST_ASSIGNEE_FILTER_DEBOUNCE_MS,
  fetchConversations = null,
  resetTimer = null,
  scheduleTimer = null,
} = {}) => {
  if (
    typeof fetchConversations !== 'function' ||
    typeof resetTimer !== 'function' ||
    typeof scheduleTimer !== 'function'
  ) {
    return null;
  }

  if (currentTimer && typeof clearTimer !== 'function') {
    return null;
  }

  if (currentTimer) {
    clearTimer(currentTimer);
  }

  return scheduleTimer(() => {
    resetTimer();
    fetchConversations(1);
  }, delayMs);
};

export const runChatListAssigneeFilterChange = ({
  abortConversationFetch = null,
  agentId = null,
  clearBulkSelection = null,
  clearSearchResults = null,
  clearTimer = null,
  closeConversation = null,
  currentChat = null,
  currentTimer = null,
  delayMs = CHAT_LIST_ASSIGNEE_FILTER_DEBOUNCE_MS,
  fetchConversations = null,
  resetTimer = null,
  scheduleAssigneeFetch = scheduleChatListAssigneeFilterFetch,
  scheduleTimer = null,
  selectedAssigneeIdFilter = null,
  setAssigneeDebounceTimer = null,
  setCurrentPage = null,
  setSelectedAssigneeIdFilter = null,
} = {}) => {
  if (selectedAssigneeIdFilter === agentId) {
    return { status: 'unchanged', timer: currentTimer };
  }

  if (typeof clearSearchResults === 'function') {
    clearSearchResults();
  }
  if (typeof clearBulkSelection === 'function') {
    clearBulkSelection();
  }
  if (typeof setSelectedAssigneeIdFilter === 'function') {
    setSelectedAssigneeIdFilter(agentId);
  }

  const activeChatId = currentChat?.id;
  if (activeChatId && typeof closeConversation === 'function') {
    closeConversation(activeChatId);
  }

  if (typeof setCurrentPage === 'function') {
    setCurrentPage(1);
  }
  if (typeof abortConversationFetch === 'function') {
    abortConversationFetch();
  }

  const timer =
    typeof scheduleAssigneeFetch === 'function'
      ? scheduleAssigneeFetch({
          clearTimer,
          currentTimer,
          delayMs,
          fetchConversations,
          resetTimer,
          scheduleTimer,
        })
      : null;

  if (typeof setAssigneeDebounceTimer === 'function') {
    setAssigneeDebounceTimer(timer);
  }

  return { status: 'scheduled', timer };
};

export const scheduleChatListPendingConversationReset = ({
  clearTimer = null,
  id = null,
  pendingConversations = null,
  pendingConversationTimers = null,
  scheduleTimer = null,
  ttlMs = CHAT_LIST_PENDING_CONVERSATION_TTL_MS,
} = {}) => {
  if (
    id == null ||
    id === '' ||
    !pendingConversations ||
    typeof pendingConversations.add !== 'function' ||
    typeof pendingConversations.delete !== 'function' ||
    !pendingConversationTimers ||
    typeof pendingConversationTimers !== 'object' ||
    typeof clearTimer !== 'function' ||
    typeof scheduleTimer !== 'function'
  ) {
    return null;
  }

  pendingConversations.add(id);
  clearTimer(pendingConversationTimers[id]);

  const timer = scheduleTimer(() => {
    pendingConversations.delete(id);
    delete pendingConversationTimers[id];
  }, ttlMs);

  pendingConversationTimers[id] = timer;
  return timer;
};

export const runChatListPendingConversationTimersClear = ({
  clearTimer = null,
  pendingConversationTimers = null,
  resetPendingConversationTimers = null,
} = {}) => {
  if (
    typeof clearTimer !== 'function' ||
    !pendingConversationTimers ||
    typeof pendingConversationTimers !== 'object' ||
    typeof resetPendingConversationTimers !== 'function'
  ) {
    return { clearedCount: 0, status: 'invalid' };
  }

  const timers = Object.values(pendingConversationTimers);
  timers.forEach((timer) => {
    clearTimer(timer);
  });
  resetPendingConversationTimers({});

  return { clearedCount: timers.length, status: 'cleared' };
};

export {
  CHAT_LIST_EMPTY_CONVERSATIONS_ACTION,
  CHAT_LIST_PAGE_RESET_ACTION,
  CHAT_LIST_CLEAR_CONVERSATION_CACHE_ACTION,
  CHAT_LIST_CLEAR_SELECTED_CONVERSATION_ACTION,
  CHAT_LIST_SET_PAGINATION_LOADING_STATUS_ACTION,
  CHAT_LIST_BULK_CLEAR_SELECTION_ACTION,
  CHAT_LIST_BULK_EMAIL_BATCH_ARCHIVE_ACTION,
  CHAT_LIST_BULK_EMAIL_BATCH_MOVE_ACTION,
  CHAT_LIST_BULK_EMAIL_BATCH_TRASH_ACTION,
  CHAT_LIST_UPDATE_FILTERS_ACTION,
  CHAT_LIST_TOGGLE_STATUS_ACTION,
  CHAT_LIST_SET_UNREAD_FIRST_ACTION,
  CHAT_LIST_SET_PRIORITY_FILTER_ACTION,
  CHAT_LIST_SET_CONTEXT_MENU_CHAT_ID_ACTION,
  CHAT_LIST_SET_CHAT_SORT_FILTER_ACTION,
  CHAT_LIST_CHAT_SORT_FILTER_GETTER,
  CHAT_LIST_SET_CHAT_LIST_FILTERS_ACTION,
  CHAT_LIST_ASSIGN_MICROSOFT_FOLDERS_ACTION,
  CHAT_LIST_ASSIGN_IMAP_FOLDERS_ACTION,
  CHAT_LIST_ASSIGN_GMAIL_LABELS_ACTION,
  CHAT_LIST_CURRENT_PAGE_FILTER_GETTER,
  CHAT_LIST_BULK_SET_SELECTION_ACTION,
  CHAT_LIST_BULK_REMOVE_SELECTION_ACTION,
  CHAT_LIST_BULK_PROCESS_ACTION,
  CHAT_LIST_BULK_SELECTED_IDS_GETTER,
  CHAT_LIST_SET_CONVERSATION_FILTERS_ACTION,
  CHAT_LIST_SET_CHAT_STATUS_FILTER_ACTION,
  CHAT_LIST_SET_ACTIVE_INBOX_ACTION,
  CHAT_LIST_MARK_MESSAGES_UNREAD_ACTION,
  CHAT_LIST_FETCH_FILTERED_ACTION,
  CHAT_LIST_FETCH_CACHED_ACTION,
  CHAT_LIST_FETCH_ALL_ACTION,
  CHAT_LIST_CLOSE_CONVERSATION_ACTION,
  CHAT_LIST_CLEAR_CONVERSATION_FILTERS_ACTION,
  CHAT_LIST_TOGGLE_STARRED_ACTION,
  CHAT_LIST_ASSIGN_PRIORITY_ACTION,
  CHAT_LIST_PREFETCH_MESSAGES_ACTION,
  CHAT_LIST_REMOVE_RESOLVED_CONVERSATIONS_ACTION,
  CHAT_LIST_CONVERSATION_ASSIGNEE_ID_FIELD,
  CHAT_LIST_CONVERSATION_META_ASSIGNEE_FIELD,
  CHAT_LIST_CONVERSATION_LABELS_FIELD,
  CHAT_LIST_UPDATE_LAST_ACTIVITY_MUTATION,
  CHAT_LIST_SET_LOADING_STATUS_MUTATION,
  buildChatListRootListenerEntries,
  buildChatListEmitterListenerEntries,
  applyChatListRootListenerEntries,
  buildChatListEmitterListenerContext,
  buildChatListEmitterEmitContext,
  buildChatListStoreActionContext,
  buildChatListChangeConversationStatusPayload,
} from './chatListStoreContext';

export const readChatListInboxLabelsSafely = ({
  inboxId = null,
  getInboxLabels = () => null,
} = {}) => {
  try {
    const result =
      typeof getInboxLabels === 'function' ? getInboxLabels(inboxId) : null;
    const labels = Array.isArray(result) ? result : [];
    return {
      inboxLabels: labels,
      labelsReady: labels.length > 0,
    };
  } catch (_) {
    return {
      inboxLabels: [],
      labelsReady: true,
    };
  }
};
